import { render, staticRenderFns } from "./studentIdInput.vue?vue&type=template&id=3e775a38&scoped=true"
import script from "./studentIdInput.vue?vue&type=script&lang=js"
export * from "./studentIdInput.vue?vue&type=script&lang=js"
import style0 from "./studentIdInput.vue?vue&type=style&index=0&id=3e775a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e775a38",
  null
  
)

export default component.exports